<template>
  <div class="footer">

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>